import {
  Assessment,
  Assignment,
  Dvr,
  FindInPage,
  ImportContacts,
  People,
  PersonAdd,
  PieChart,
  RecentActors,
  School,
  SupervisedUserCircle,
} from '@material-ui/icons';
import {Roles, SHOW_SPAC_FEATURES} from 'app/Constants';
import * as Pages from 'features';
import {CoursePage} from 'features/course/';
import {DashboardPage} from 'features/dashboard';
import {RequirementPage} from 'features/requirement';
import React from 'react';

const navigationRoutes = [
  {
    menuProps: {
      title: 'Mi tablero',
      icon: <PieChart style={{color: '#4040a1'}} />,
    },
    path: 'Dashboard',
    component: DashboardPage,
    role: [
      Roles.AdminHSE,
      Roles.AdminITPS,
      Roles.AdminQA,
      Roles.Trainer,
      Roles.Collaborator,
    ],
  },
  {
    menuProps: {
      title: 'Actividad',
      icon: <ImportContacts style={{color: '#4040a1'}} />,
    },
    path: 'Activity',
    component: Pages.Activity,
    role: [
      Roles.AdminHSE,
      Roles.AdminITPS,
      Roles.AdminQA,
      Roles.Trainer,
      Roles.Collaborator,
    ],
  },
  {
    menuProps: {
      title: 'Gestion de capacitaciones',
      icon: <PersonAdd style={{color: '#4040a1'}} />,
    },
    path: 'Management',
    component: Pages.InstanceManagement,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    menuProps: {
      title: 'Módulo Reporting',
      icon: <Assessment style={{color: '#4040a1'}} />,
    },
    path: 'consult',
    component: Pages.ConsultPage,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    group: 'Consult',
    iconGroup: <FindInPage style={{color: '#4040a1'}} />,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
    items: [
      {
        menuProps: {
          title: 'Requirements',
          icon: <People style={{color: '#4040a1'}} />,
        },
        path: 'ReadRequirements',
        component: RequirementPage,
        role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
      },
      {
        menuProps: {
          title: 'Colaboradores por capacitacion',
          icon: <SupervisedUserCircle style={{color: '#4040a1'}} />,
        },
        path: 'ReadCollaborators',
        component: Pages.CollaboratorReadOnly,
        role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
      },
      {
        menuProps: {
          title: 'Instancias por capacitacion',
          icon: <School style={{color: '#4040a1'}} />,
        },
        path: 'ReadStages',
        component: Pages.instanceReadOnly,
        role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
      },
      {
        menuProps: {
          title: 'Capacitaciones pendientes por sector',
          icon: <Assignment style={{color: '#4040a1'}} />,
        },
        path: 'ReadStagesBySector',
        component: Pages.SectorsReadOnly,
        role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
      },
      ...(SHOW_SPAC_FEATURES
        ? [
            {
              menuProps: {
                title: 'Capacitaciones pendientes por SPAC',
                icon: <Dvr style={{color: '#4040a1'}} />,
              },
              path: 'ReadStagesBySpac',
              component: Pages.SpacReadOnly,
              role: [Roles.AdminITPS],
            },
          ]
        : []),
      {
        menuProps: {
          title: 'Capacitación Colaboradores',
          icon: <RecentActors style={{color: '#4040a1'}} />,
        },
        path: 'ReadCollaboratorsMD',
        component: Pages.CollaboratorReadOnlyMD,
        role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
      },
    ],
  },
  {
    path: 'Management-Instance',
    component: Pages.Management,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  ...(SHOW_SPAC_FEATURES
    ? [
        {
          path: 'Management-SPAC',
          component: Pages.Management,
          role: [Roles.AdminITPS],
        },
      ]
    : []),
  {
    path: 'Settings',
    component: Pages.Settings,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'CollaboratorsDetails',
    component: Pages.CollaboratorDetailsOfReadOnly,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'ReadStagesDetail',
    component: Pages.InstanceReadOnlyDetail,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'ReadCourses',
    component: CoursePage,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'ReadStagesBySectorDetails',
    component: Pages.SectorsReadOnlyDetail,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'Capacitation',
    component: Pages.Capacitation,
    role: [
      Roles.AdminHSE,
      Roles.AdminITPS,
      Roles.AdminQA,
      Roles.Trainer,
      Roles.Collaborator,
    ],
  },
  {
    path: 'Course',
    component: Pages.EditCourse,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'TabletCourse',
    component: Pages.TableCourse,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
  {
    path: 'confirmCredentials',
    component: Pages.ConfirmCredentials,
    role: [Roles.AdminHSE, Roles.AdminITPS, Roles.AdminQA, Roles.Trainer],
  },
];

export default navigationRoutes;
